import {AfterContentChecked, Component, ElementRef, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';


@Component({
  selector: 'app-trial-limits-dialog',
  templateUrl: './trial-limits.component.html',
  styleUrls: ['./trial-limits.component.scss']
})
export class TrialLimitsComponent implements AfterContentChecked   {

  private positionRelativeToElement: ElementRef;

  constructor(public dialogRef: MatDialogRef<TrialLimitsComponent>,
              @Inject(MAT_DIALOG_DATA) public options: { positionRelativeToElement: ElementRef }
  ) {
    this.positionRelativeToElement = options.positionRelativeToElement;
  }

  ngAfterContentChecked() {
    const matDialogConfig = new MatDialogConfig();
    // @ts-ignore
    const rect: DOMRect = this.positionRelativeToElement._elementRef.nativeElement.getBoundingClientRect();
    matDialogConfig.position = {left: `${rect.left - 230}px`, top: `${rect.top - 190}px`};
    this.dialogRef.updatePosition(matDialogConfig.position);
  }

}
